import { HttpResponse } from '@angular/common/http';
import { Component, Input, SimpleChanges } from '@angular/core';
import { LookupService } from 'src/app/demo/service/lookup.service';
import { Common } from 'src/app/demo/utils/common';
import { profielBackgroundColor } from '../../constants/profielBackgroundColor';
import * as moment from 'moment';

@Component({
  selector: 'app-recent-movements',
  templateUrl: './recent-movements.component.html',
  styleUrls: ['./recent-movements.component.scss']
})
export class RecentMovementsComponent {

  @Input() schoolId!: number;
  @Input() currentRoomId?: number;
  @Input() staffRooms!: any;

  latestMoves!: any;
  userData!: any;
  search: any = {};
  pageContext = {
    page: 0,
    previousPage: 0,
    itemsPerPage: 10,
    totalItems: 0,
    sort: 'id,desc',
  };
  backgroundColors: string[] = [];



  constructor(private lookupService: LookupService) {
        this.backgroundColors = profielBackgroundColor;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.schoolId) return;

    this.search = {
      size: 100,
      sort: ['movementDate,asc'],
      'schoolId.equals': this.schoolId,
      'status.equals': 'A',
      'enrollmentStatus.in': ['Overdue', 'Upcoming', 'Confirmed']
    };

    if (this.currentRoomId != null) {
      this.search['currentRoomId.equals'] = this.currentRoomId;
    } else if (this.staffRooms != null) {
      this.search['currentRoomId.equals'] = this.staffRooms;
    }

    Common.removeEmptyFields(this.search);

    this.lookupService.queryFutureEnrollment(this.search).subscribe({
      next: (data: any) => {
        const moves = Array.isArray(data?.body) ? data.body : [];
        this.latestMoves = this.groupAndSortMoves(moves);
      },
      error: (err) => {
        console.error('Failed to load future enrollments:', err);
        this.latestMoves = [];
      }
    });
  }

  groupAndSortMoves(data: any[]): any[] {
    const groupedMap = new Map();

    try {
      data.forEach((move) => {
        const key = `${move.currentRoomId}-${move.nextRoomId}-${move.movementDate}-${move.enrollmentStatus}`;
        if (!groupedMap.has(key)) {
          groupedMap.set(key, {
            currentRoomId: move.currentRoomId,
            nextRoomId: move.nextRoomId,
            movementDate: move.movementDate,
            enrollmentStatus: move.enrollmentStatus,
            students: [],
            currentRoom: move.currentRoom,
            nextRoom: move.nextRoom,
            isLeaving: move.isLeaving
          });
        }
        const student = {
          id: move.studentId,
          name: move.studentName,
          photoUuid: move.studentPhotoUuid,
          profileimg: '',
        };

        if (student.photoUuid) {
          this.lookupService.queryDocumentByPhotoUid(student.photoUuid).subscribe((response: HttpResponse<Blob>) => {
            if (response.body) {
              const url = this.createImgFromBuffer(response.body);
              student.profileimg = url;
            }
          });
        }

        groupedMap.get(key).students.push(student);
      });
      const groupedArray = Array.from(groupedMap.values());

      const overdue = groupedArray.filter(g => g.enrollmentStatus === 'Overdue');
      const upcomingConfirmed = groupedArray
        .filter(g => g.enrollmentStatus === 'Upcoming' || g.enrollmentStatus === 'Confirmed')
        .sort((a, b) => new Date(a.movementDate).getTime() - new Date(b.movementDate).getTime());

      return [...overdue, ...upcomingConfirmed].slice(0, 3);
    } catch (error) {
      console.error('Error in groupAndSortMoves:', error);
      return [];
    }
  }

  getStudentNames(students: any[]): string {
    if (!students || students.length === 0) return '';
    return students.map(s => s.name).join(', ');
  }

  createImgFromBuffer(blob: Blob) {
    const url = URL.createObjectURL(blob);
    return url;
  }

  getInitials(roomName?: string): string {
    if (!roomName?.trim()) return ''; 
    const words = roomName.trim().split(/[-\s]+/);
    const firstLetter = words[0]?.[0]?.toUpperCase() || '';
    const secondLetter = words[1]?.[0]?.toUpperCase() || '';
    return `${firstLetter}${secondLetter}`.trim();
  }
  

  getBackgroundColor(roomId: number): string {
    if (!roomId) return this.backgroundColors[0];
    const index = (roomId - 1) % this.backgroundColors.length;
    return this.backgroundColors[index];
  }

  formatMonth(dateStr: string): string {
    return moment.utc(dateStr).format('MMM');
  }
  
  formatDay(dateStr: string): string {
    return moment.utc(dateStr).format('DD');
  }


}
